const DEMO_CLASS_TITLES = new Set([
  'Example: Outdoor Photography Workshop',
  'Example: Culinary Workshop',
  'Example: Digital Arts Class',
]);

export function isDemoClassTitle(title: string | null | undefined): boolean {
  return !!title && DEMO_CLASS_TITLES.has(title);
}
